export default "__VITE_ASSET__tKVvyO9k__"